<template>
  <div class="testDialog">
    <el-dialog title="测试发送" :visible="testDialog" @close="oncancel">
      <div v-show="isshow == 1">
        <ul class="topinfo">
          <li>
            <div class="blurCir">1</div>
            <div style="margin-left: 20px">
              <p class="ttext">基本信息</p>
              <p class="btext">填写测试发送发信息</p>
            </div>
          </li>
          <li></li>
          <li>
            <div class="grayCir">2</div>
            <div style="margin-left: 20px">
              <p class="ttext">确认并发送</p>
              <p class="btext">确定测试发送信息</p>
            </div>
          </li>
        </ul>
        <el-form :rules="rules" :model="form">
          <el-form-item
            label="手机号码："
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-input
              placeholder="请输入手机号码"
              v-model="form.name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="短信签名："
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-select v-model="form.region" placeholder="选择已添加的短信签名">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="短信模板："
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-select v-model="form.region2" placeholder="选择已添加模版">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="f2" ref="m1">
          <div class="f2_top">
            <div class="f2_top_1">内容变量</div>
            <div @click="add" class="f2_top_2">
              <span style="font-size: 20px; margin-right: 5px">+</span>插入变量
            </div>
          </div>
          <el-form :rules="rules" :model="form" ref="m2">
            <template v-for="(i, index) in content">
              <el-form-item
                label="变量名称："
                :label-width="formLabelWidth"
                prop="name"
              >
                <el-input
                  placeholder="请输入变量名称"
                  v-model="i.a"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="选择变量："
                :label-width="formLabelWidth"
                prop="name"
              >
                <el-select v-model="i.b" placeholder="请输入变量名称">
                  <el-option label="区域一" value="shanghai"></el-option>
                  <el-option label="区域二" value="beijing"></el-option>
                </el-select>
              </el-form-item>
              <span class="remove" @click="remove(index)">删除</span>
            </template>
          </el-form>
        </div>
      </div>
      <div class="div2" v-show="isshow == 2">
        <ul class="topinfo">
          <li>
            <div class="grayCir">1</div>
            <div style="margin-left: 20px">
              <p class="ttext">基本信息</p>
              <p class="btext">填写测试发送发信息</p>
            </div>
          </li>
          <li></li>
          <li>
            <div class="blurCir">2</div>
            <div style="margin-left: 20px">
              <p class="ttext">确认并发送</p>
              <p class="btext">确定测试发送信息</p>
            </div>
          </li>
        </ul>
        <ul class="end">
          <li>
            <p>
              <span class="red">*</span><span class="s2">手机号码：</span
              ><span class="s3">13691698530</span>
            </p>
          </li>
          <li>
            <p>
              <span class="red">*</span><span class="s2">短信签名：</span
              ><span class="s3">GYMOO</span>
            </p>
          </li>
          <li>
            <p>
              <span class="red">*</span><span class="s2">短信模板：</span
              ><span class="s3">请输入变量名称</span>
            </p>
          </li>
          <li>
            <p>
              <span class="red">*</span><span>内容变量：</span
              ><span
                ><el-tag>code</el-tag><el-tag>order</el-tag
                ><el-tag>变量参数</el-tag></span
              >
            </p>
          </li>
        </ul>
      </div>
      <div class="hx"></div>
      <div v-if="isshow == 1" slot="footer" class="dialog-footer">
        <el-button @click="oncancel" round>取 消</el-button>
        <el-button type="primary" @click="isshow = 2" round>确 定</el-button>
      </div>
      <div v-if="isshow == 2" slot="footer" class="dialog-footer">
        <el-button @click="isshow = 1" round>上一步</el-button>
        <el-button type="primary" @click="send()" round>发 送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["testDialog", "num"],
  data() {
    return {
      //渲染内容变量的数组
      content: [
        {
          a: "",
          b: "",
        },
        {
          a: "",
          b: "",
        },
        {
          a: "",
          b: "",
        },
      ],
      //点击确认后弹出第二个框
      isshow: 1,
      dialogFormVisible: true,
      form: {
        name: "",
        name2: "",
        name3: "",
        name4: "",
        name5: "",
      },
      formLabelWidth: "120px",
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      imgUrl: require("@/assets/images/ticons/time.png"),
      imgUrl2: require("@/assets/images/ticons/time (1).png"),
    };
  },
  methods: {
    //测试发送点击插入变量
    add() {
      this.content.push({ a: "", b: "" });
      this.$nextTick(() => {
        this.$refs.m1.scrollTop = this.$refs.m1.scrollHeight;
      });
    },
    //测试发送点击删除
    remove(index) {
      this.content.splice(index, 1);
    },
    //点击发送
    send() {
      if (this.num == 1) {
        this.$alert(
          "<img style='display:inline-block; transform: translate(-4px, 7px);' src=" +
            this.imgUrl +
            "><span style='font-size:12px;'>失败原因：「AccessKeyId」填写错误，请前往企业配置-短信配置进行修改</span> ",
          "第三方接口调用失败",
          {
            dangerouslyUseHTMLString: true,
          }
        );
      } else {
        this.$alert(
          "<img style='display:inline-block; transform: translate(-4px, 7px);' src=" +
            this.imgUrl2 +
            "><span style='font-size:12px;'>请确认是否收到短信，若未收到短信可提交工单联系客服</span> ",
          "第三方接口调用成功",
          {
            dangerouslyUseHTMLString: true,
          }
        );
      }
      this.$emit("update:testDialog", false);
      this.isshow = 1;
    },
    oncancel() {
      this.$emit("update:testDialog", false);
      this.isshow = 1;
    },
  },
};
</script>

<style lang='less'>
.testDialog {
  position: relative;
  .el-dialog {
    width: 880px;
    height: 617px;
    position: relative;
  }
  .dialog-footer {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
  .el-dialog__body {
    margin-top: 20px;
    margin-bottom: 30px;
    .el-form {
      margin-top: 20px;
    }
    .el-input__inner {
      width: 359px;
      height: 32px;
      border-radius: 15px;
      background: #f6f6f6;
      border: 0;
    }
    .el-form-item__label {
      height: 22px;
      line-height: 31px;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
  .hx {
    position: absolute;
    left: 0;
    bottom: 70px;
    width: 100%;
    height: 1px;
    background: rgba(0, 0, 0, 0.09000000357627869);
  }
  .el-dialog__body {
    word-break: normal;
  }
  .topinfo {
    display: flex;
    align-items: center;
    margin-left: 70px;
    li {
      .blurCir {
        width: 58px;
        height: 58px;
        border-radius: 29px;
        background: linear-gradient(180deg, #587ffb 0%, #3867fb 100%);
        color: #fff;
        font-size: 30px;
        line-height: 58px;
        text-align: center;
      }
      .grayCir {
        width: 58px;
        height: 58px;
        border-radius: 29px;
        background: #d7d7d7;
        color: #fff;
        font-size: 30px;
        line-height: 58px;
        text-align: center;
      }
      &:nth-child(1) {
        display: flex;
        align-items: center;
        .ttext {
          font-size: 20px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #327eff;
        }
        .btext {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #474747;
        }
      }
      &:nth-child(2) {
        width: 177px;
        opacity: 1;
        border-top: 2px dashed #3d6bfb;
        margin-left: 80px;
        margin-right: 80px;
      }
      &:nth-child(3) {
        display: flex;
        align-items: center;
        .ttext {
          font-size: 20px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #d7d7d7;
        }
        .btext {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #d7d7d7;
        }
      }
    }
  }
  .div2 {
    .topinfo {
      li {
        &:nth-child(3) {
          display: flex;
          align-items: center;
          .ttext {
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #327eff;
          }
          .btext {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #474747;
          }
        }
        &:nth-child(2) {
          width: 177px;
          opacity: 1;
          border-top: 2px dashed #3d6bfb;
          margin-left: 80px;
          margin-right: 80px;
        }
        &:nth-child(1) {
          display: flex;
          align-items: center;
          .ttext {
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #d7d7d7;
          }
          .btext {
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #d7d7d7;
          }
        }
      }
    }
    .end {
      margin-left: 70px;
      margin-top: 50px;
      li {
        margin-top: 30px;
        .red {
          color: #e02020;
        }
        .s2 {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
        .s3 {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-left: 20px;
        }
        .el-tag {
          width: 51px;
          height: 24px;
          border-radius: 12px 12px 12px 12px;
          color: #3373fe;
          font-size: 12px;
          text-align: center;
          line-height: 24px;
          background: #e2edff;
          margin-left: 15px;
          &:nth-child(3) {
            width: 74px;
          }
        }
      }
    }
  }
  .f2 {
    box-sizing: border-box;
    margin-left: 30px;
    width: 810px;
    height: 222px;
    background: rgba(50, 126, 255, 0.06454873085021973);
    border-radius: 7px 7px 7px 7px;
    padding: 16px 23px 0px 23px;
    overflow: hidden;
    overflow-y: auto;
    .remove {
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #0091ff;
      margin-left: 26px;
      margin-top: 8px;
    }
    .f2_top {
      display: flex;
      justify-content: space-between;
      .f2_top_1 {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #33393f;
      }
      .f2_top_2 {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #0091ff;
      }
    }
    .el-form {
      display: flex;
      flex-wrap: wrap;
    }
    .el-input__inner {
      width: 212px;
      height: 32px;
      border-radius: 15px;
      background: #fff;
      border: 0;
    }
  }
}
</style>